import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { isSdkAuthenticatedAndUserLoaded } from '@boldpenguin/sdk-redux';
import { select } from '@ngrx/store';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { localStorageKeys } from 'src/app/shared/constants';
import { BpSdkStoreService } from '../../services/bp-sdk-store-service/bp-sdk-store.service';

export const unauthenticatedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
): Observable<boolean | UrlTree> => {
  const bpSdkStoreService = inject(BpSdkStoreService);
  const localStorageService = inject(LocalStorageService);
  const router = inject(Router);

  return bpSdkStoreService.isAuthenticated$.pipe(
    withLatestFrom(
      // When the userinfo endpoint returns a non-success status code that is not a 401 (500, 502, etc),
      // SDK will set an error status for auth, but not logout the user.
      // Here we grab the sdk authentication and user status, to check if the request was successful.
      bpSdkStoreService.state$.pipe(select(isSdkAuthenticatedAndUserLoaded)),
    ),
    map(([isAuthenticated, isSdkAuthed]) => isAuthenticated && isSdkAuthed),
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        localStorageService.clear(localStorageKeys.settingsEnrollmentId);
      }
      return (
        !isAuthenticated ||
        router.createUrlTree(['quotes', 'dashboard'], {
          queryParams: route.queryParams,
        })
      );
    }),
  );
};
